import { NgModule } from '@angular/core';

import { StringSubstringPipe } from './string-substring.pipe';

@NgModule({
  declarations: [StringSubstringPipe],
  exports: [StringSubstringPipe],
})
export class StringPipeModule {}
